import { request } from "../../../app/api-client/ApiClient";

/**
 * Metodo para obtener las maquinas asocuadas a un admin
 * @param {Integer} idAdmin 
 */

//usuarios por año
export function totalUsers(dispatch, id, year) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/totalusers/historic/evbi/anual/${id}/${year}`,
		method: "GET",
	}, dispatch);
}
export function Años(dispatch) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/year/list/all`,
		method: "GET",
	}, dispatch);
}
export function createUsers(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/totalusers/register`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}


//data controller

export function totalDataUsers(dispatch, id, page, size, filter) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/data/evbi/users/meditions/general/${id}?page=${page}&size=${size}&filter=${filter}`,
		method: "GET",
	}, dispatch);
}


export function totalData(dispatch, id) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/data/evbi/meditions/${id}`,
		method: "GET",
	}, dispatch);
}


//////


export function getUsersMachineBasculaDetail(dispatch, idBascula, dateInit, dateEnd) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/data/evbi/users/meditions/${idBascula}/${dateInit}/${dateEnd}`,
		method: "GET",
	}, dispatch);
}


///usuarios general

export function getUsuarios(dispatch) {

	return request({
		url: `${process.env.REACT_APP_API_URL}/api/admin/list/email/status/-/-`,
		method: "GET",
	}, dispatch);
}
export function createUsersgeneral(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_URL}/api/admin/signup/admin`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}
export function EditarUSersGeneral(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_URL}/api/admin/edit/admin/`;
	return request({
		url: url,
		method: "PUT",
		body: JSON.stringify(Request),
	}, dispatch);
}
export function updateStatusUser(dispatch, id) {
	let url = `${process.env.REACT_APP_API_URL}/api/admin/change/status/${id}`;
	return request({
		url: url,
		method: "PUT",
	}, dispatch);
}
export function updateRolAuth(dispatch, id, rol) {
	let url = `${process.env.REACT_APP_API_URL}/api/admin/edit/rol/${id}/${rol}`;
	return request({
		url: url,
		method: "PUT",
	}, dispatch);
}
export function assignEvbi(dispatch, Request) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/useradmin/assign/evbi`,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}
export function DeleteEvbi(dispatch, Request) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/cliente/assing`,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}



//////////// historico 
export function getHistorico(dispatch, documento, idBascula) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/user/historic/${documento}/${idBascula}`,
		method: "GET",
	}, dispatch);
}
export function getHistoricoDocumento(document, dataStart, dataEnd) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/alcoholimetro/historico/totales/user/${document}?datestart=${dataStart}&dateend=${dataEnd}`,
		method: "GET",
	});
}
export function getRangos(key) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/rango/module/${key}`,
		method: "GET",
	});
}
export function consultaValTelAndIMC(tel) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/user/findByCellphone/type/${tel}/IMC`,
		method: "GET",
	});
}
export function consultaResultadosEncuesta(tel) {
	return request({
		url: `${process.env.REACT_APP_API_POLL}/v1/poll/AnswersUserByPollAndCel/13/${tel}`,
		method: "GET",
	});
}



///cambio de contraseña


export function ChanguePAss(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_URL}/api/v1/admin/changePassword`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}

///restablecer contraseña

export function RestartPass(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_URL}/api/v1/admin/RestartPassword`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}

